import React from 'react';
import PropTypes from 'prop-types';
import { FundSummaryContainer, FundSummaryContent } from './styles';

function PageSummary(props) {
  const { fundSummaryConfig = [] } = props;
  return (
    <FundSummaryContainer>
      {fundSummaryConfig.map((each, index) => (
        <FundSummaryContent isColumn={each.props.dataName === 'accountName'} key={index}>
          {each}
        </FundSummaryContent>
      ))}
    </FundSummaryContainer>
  );
}
PageSummary.propTypes = {
  fundSummaryConfig: PropTypes.array
}
export default PageSummary;
